module.exports = __webpack_public_path__ + "4046f582a837108d55fc9a897397f56e.svg";